export interface EventFormData {
  name: string;
  location: string;
  description: string;
  slots: string;
  status: 'Scheduled' | 'Active';
  startDate: string;
  endDate: string;
  departments: string[];
}

export const validateForm = (formData: EventFormData): string | null => {
  if (!formData.name.trim() || !formData.location.trim()) {
    return 'Please fill in name and location';
  }

  if (!formData.status) {
    return 'Please select a status';
  }

  const slotsValue = parseInt(formData.slots, 10);
  if (!formData.slots || isNaN(slotsValue) || slotsValue <= 0) {
    return 'Please enter a valid number of slots';
  }
  if (slotsValue > 100) {
    return 'Maximum slots is 100';
  }

  if (formData.status === 'Scheduled' && (!formData.startDate || !formData.endDate)) {
    return 'Please select both start and end dates for scheduled events';
  }

  // departments are optional (can be empty); shifts are validated separately
  return null;
};

export const validateImage = (file: File): string | null => {
  if (file.size > 5 * 1024 * 1024) {
    return 'Image size must be less than 5MB';
  }
  return null;
};

export const validateDepartment = (
  newDepartment: string,
  departments: string[],
  maxDepartments: number = 15
): string | null => {
  if (departments.length >= maxDepartments) {
    return 'Maximum Reached: You can add a maximum of 15 departments.';
  }
  if (departments.includes(newDepartment.trim())) {
    return 'Duplicate Department: This department has already been added.';
  }
  return null;
};
